import * as React from 'react';
import { CustomBalanceOption } from './CustomBalanceOption';
import { balances } from '../../../constants/pricing';

interface CustomBalanceSelectorProps {
  setIsBalanceOptionsOpen
  balance,
  isBalanceOptionsOpen,
  freeBalance,
  handleBalanceOptionClick,
  reactRef
}

export const CustomBalanceSelector = ({
  setIsBalanceOptionsOpen, balance, reactRef,
  isBalanceOptionsOpen, freeBalance, handleBalanceOptionClick,
}: CustomBalanceSelectorProps) => {
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (reactRef.current && !reactRef.current.contains(event.target)) {
        setIsBalanceOptionsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [reactRef]);

  const balanceOptions = balances.map((b, idx) => (
    <div
      key={b}
      role="button"
      tabIndex={0}
      className="custom-option"
      data-value={b}
      onClick={handleBalanceOptionClick}
      onKeyPress={handleBalanceOptionClick}
    >
      <CustomBalanceOption
        isFirstOption={idx === 0}
        balance={b}
        freeBalance={freeBalance}
      />
    </div>
  ));

  return (
    <div ref={reactRef} className="custom-select-wrapper">
      <div className="custom-select">
        <div
          role="button"
          tabIndex={0}
          className="custom-select-trigger"
          onClick={() => setIsBalanceOptionsOpen(!isBalanceOptionsOpen)}
          onKeyPress={() => setIsBalanceOptionsOpen(!isBalanceOptionsOpen)}
        >
          <CustomBalanceOption
            isFirstOption={balance === 0}
            balance={balance}
            freeBalance={freeBalance}
          />
        </div>
        <div className={`custom-options ${isBalanceOptionsOpen ? '' : 'hide'}`}>{balanceOptions}</div>
      </div>
    </div>
  );
};
